import { useTranslation } from "react-i18next";
import { Outlet, useLocation } from "react-router-dom";
import { useJoinContext } from "components/context/joinContext";
import { useEffect } from "react";
import "./join.scss";

type IProps = {};

export default function JoinLayout({}: IProps) {
  const { t } = useTranslation();
  const { pathname, state } = useLocation();

  const { onJoinInf } = useJoinContext();

  const subTitles = [
    "sb_ttl_sng_stp_1",
    "sb_ttl_sng_stp_2",
    "sb_ttl_sng_stp_3",
    "sb_ttl_sng_stp_4",
  ];

  const joinStep =
    pathname === "/join/term"
      ? 1
      : pathname === "/join/mail"
      ? 2
      : pathname === "/join/pwd"
      ? 3
      : pathname === "/join/inf"
      ? 4
      : 0;

  useEffect(() => {
    if (state) {
      onJoinInf(state);
      // localStorage.setItem("joinInf", JSON.stringify(state));
    }
  }, []);

  return (
    <>
      <div className="">
        <h1>{state?.title || t("ttl_sgn")}</h1>
        <p className="text-blue-300 text-center text-xs md:text-sm">
          {t("ttl_dscrp_sng_stp_1")}
        </p>
        <div className="progress-bar">
          <span className={"step" + joinStep + ""} />
        </div>
        {!!subTitles[joinStep - 1] && (
          <h3 className="">{t(subTitles[joinStep - 1])}</h3>
        )}
      </div>
      <Outlet />
    </>
  );
}
